import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const Statistics = (props: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 15 19"
    {...props}
    sx={{ fill: 'none', ...(props.sx || {}) }}
  >
    <path
      d="M13.6617 18.0023V7.37598"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.10411 18.0021V1"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.546438 18.0011V11.626"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
